<template>
  <v-container
    id="regular-tables-view"
    tag="section"
  >
    <view-intro
      heading="Xудалдаж авсан xичээлүүд"
      link="components/simple-tables"
    />

    <material-card
      icon="mdi-clipboard-text"
      icon-small
      title="Xудалдаж авсан xичээлүүд"
      color="accent"
    >
      <v-simple-table>
        <thead>
          <tr>
            <th class="primary--text">
              ID
            </th>
            <th class="primary--text">
              Name
            </th>
            <th class="primary--text">
              Date
            </th>
            <th class="text-right primary--text">
              Price
            </th>
          </tr>
        </thead>

        <tbody>
          <tr>
            <td>1</td>
            <td>Critical Thinking</td>
            <td>2021/01/2</td>
            <td class="text-right">
              ₮120,000
            </td>
          </tr>

          <tr>
            <td>2</td>
            <td>Critical Thinking-I</td>
            <td>2021/01/2</td>
            <td class="text-right">
              ₮120,000
            </td>
          </tr>

          <tr>
            <td>3</td>
            <td>Бүтээлч сэтгэлгээ</td>
            <td>2021/01/4</td>
            <td class="text-right">
              ₮80,000
            </td>
          </tr>

          <tr>
            <td>4</td>
            <td>Xиймэл оюуныг Маркетингт ашиглаx</td>
            <td>2021/01/4</td>
            <td class="text-right">
              ₮150,000
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </material-card>

    <div class="py-3" />
  </v-container>
</template>

<script>
  export default {
    name: 'RegularTablesView',
  }
</script>
